/* Veem PDP. Twee onderdelen:
   1) kortingschip naast de prijs (uit compare-at vs prijs);
   2) Sklum-model kleurkiezer: egale kleurbolletjes (hex per variant uit
      metafield custom.kleur_hexes, door theme.liquid als #veem-kleurmap in de
      pagina gezet) + galerijfilter per gekozen kleur via een CSS-regel op het
      alt-token "vk:<variantId>". De filterregel staat in een <style>-element
      en overleeft Horizon's her-renders, zodat er niets flikkert: alleen een
      echte kleurwissel vervangt de regel. */
(function () {
  function discountChip() {
    var box = document.querySelector(".product-information product-price");
    if (!box || box.querySelector(".veem-chip")) return;
    var cmp = box.querySelector(".compare-at-price");
    var cur = box.querySelector(".price:not(.compare-at-price)");
    if (!cmp || !cur) return;
    var num = function (el) {
      var t = (el.textContent || "").replace(/[^0-9,\.]/g, "").replace(/\.(?=\d{3})/g, "").replace(",", ".");
      return parseFloat(t);
    };
    var was = num(cmp), nu = num(cur);
    if (!(was > 0) || !(nu > 0) || nu >= was) return;
    var pct = Math.round((1 - nu / was) * 100);
    if (pct < 5) return;
    var chip = document.createElement("span");
    chip.className = "veem-chip";
    chip.textContent = "-" + pct + "%";
    box.appendChild(chip);
  }

  var kleuren = {};
  try {
    var el = document.getElementById("veem-kleurmap");
    if (el) kleuren = JSON.parse(el.textContent) || {};
  } catch (e) {}

  var stijl = null;
  var huidigeVid = null;
  function zetFilter(vid) {
    if (!vid || vid === huidigeVid) return;
    huidigeVid = vid;
    if (!stijl) {
      stijl = document.createElement("style");
      stijl.id = "veem-galerij-stijl";
      document.head.appendChild(stijl);
    }
    // media met vk-token van een ANDERE kleur verbergen; ongelabelde media
    // (sfeer/maatvoering) blijven altijd zichtbaar. ALLE oppervlakken waar
    // productmedia renderen: raster, mobiele slideshow, zoomdialoog
    // (hoofdslides + thumbnailstrip) — les 02-09: zoom was eerst vergeten.
    var niet = ':has(img[alt*="vk:"]):not(:has(img[alt*="vk:' + vid + '"]))';
    var css =
      '.media-gallery__grid > li' + niet + ',' +
      'slideshow-slide' + niet + ',' +
      'dialog.dialog-zoomed-gallery__dialog li.product-media-container' + niet + ',' +
      '.dialog-thumbnails-list > button' + niet + '{display:none !important}';
    // Sam 01-10 (go op vs-sitetest-kleur-*: "ja naar de stockimage voor die kleur"): bij een ANDERE kleur
    // dan de hoofdkleur komen de beelden van die kleur vooraan, vóór de ongelabelde (AI-)hero's die de
    // hoofdkleur tonen. Bij de hoofdkleur blijft de volgorde zoals geplaatst (hero eerst).
    if (vid !== hoofdVid()) {
      var wel = ':has(img[alt*="vk:' + vid + '"])';
      css += '.media-gallery__grid > li' + wel + ',slideshow-slide' + wel + '{order:-1}';
    }
    stijl.textContent = css;
    // mobiele slideshow terug naar het begin, anders staat hij op een nu verborgen/verschoven slide
    var track = document.querySelector("slideshow-slides");
    if (track && track.scrollLeft) { try { track.scrollTo({ left: 0, behavior: "instant" }); } catch (e) { track.scrollLeft = 0; } }
  }

  // hoofdkleur = de kleur van het eerste gelabelde beeld in de galerij (zo zijn de media geplaatst)
  var _hoofdVid = null;
  function hoofdVid() {
    if (_hoofdVid) return _hoofdVid;
    var img = document.querySelector('.media-gallery__grid img[alt*="vk:"], slideshow-slide img[alt*="vk:"]');
    if (!img) return null;
    var m = /vk:(\d+)/.exec(img.getAttribute("alt") || "");
    if (m) _hoofdVid = m[1];
    return _hoofdVid;
  }

  function syncDots() {
    // de slideshow-puntjes zijn index-gebaseerd ("Dia n van N") en weten
    // niets van het kleurfilter: verberg elk puntje waarvan de slide door
    // de filterregel verborgen is (les 03-09: 50+ puntjes op mobiel)
    // let op: de galerij is het custom element <media-gallery> (tag, geen class)
    var mg = document.querySelector("media-gallery") || document;
    var slides = mg.querySelectorAll("slideshow-slide");
    var dots = mg.querySelectorAll(".slideshow-controls__dots > li");
    if (!slides.length || dots.length !== slides.length) return;
    // eerst alles lezen, dan pas schrijven: afwisselend lezen/schrijven liet de browser
    // per slide de stijl opnieuw berekenen (layout thrashing, 24-09)
    var weg = [];
    for (var i = 0; i < slides.length; i++) weg.push(getComputedStyle(slides[i]).display === "none");
    for (var j = 0; j < slides.length; j++) if (dots[j].hidden !== weg[j]) dots[j].hidden = weg[j];
  }

  function kleurFieldset(fs) {
    var legend = fs.querySelector("legend");
    if (!legend) return false;
    var naam = (legend.childNodes[0] ? legend.childNodes[0].textContent : legend.textContent) || "";
    return /^(kleur|colou?r)\b/i.test(naam.trim());
  }

  function bouw() {
    document.querySelectorAll("fieldset.variant-option--buttons").forEach(function (fs) {
      if (!kleurFieldset(fs)) return;
      var gekozen = "";
      fs.querySelectorAll("label.variant-option__button-label").forEach(function (lb) {
        var input = lb.querySelector("input[type=radio]");
        if (!input) return;
        var vid = input.getAttribute("data-variant-id");
        var hex = kleuren[vid];
        if (!hex) return; // geen kleur bekend: knop blijft tekst-pill
        if (fs.dataset.veemSwatch !== "1") fs.classList.add("veem-swatches");
        // uitverkochte kleuren blijven aanklikbaar (galerij/prijs wisselen mee)
        if (input.disabled) input.disabled = false;
        if (!lb.querySelector(".veem-swatch")) {
          var s = document.createElement("span");
          s.className = "veem-swatch";
          s.style.backgroundColor = hex;
          lb.insertBefore(s, lb.firstChild);
        }
        if (lb.title !== input.value) lb.title = input.value;
        if (input.checked) gekozen = input.value;
      });
      fs.dataset.veemSwatch = "1";
      // legend: "Kleur: <naam>" met de naam in grijs (Sklum-model)
      var legend = fs.querySelector("legend");
      if (legend && gekozen) {
        if (legend.childNodes.length && legend.childNodes[0].nodeType === 3) {
          var kaal = legend.childNodes[0].textContent.replace(/:\s*$/, "").trim();
          if (legend.childNodes[0].textContent !== kaal + ": ") legend.childNodes[0].textContent = kaal + ": ";
        }
        var lbl = legend.querySelector(".veem-swatch-gekozen") || document.createElement("span");
        lbl.className = "veem-swatch-gekozen";
        // alleen schrijven bij verschil: elke schrijfactie is een DOM-mutatie die de observer
        // hieronder weer triggert (24-09: eindeloze lus, 158 s CPU op mobiel per productpagina)
        if (lbl.textContent !== gekozen) lbl.textContent = gekozen;
        if (!lbl.parentNode) legend.appendChild(lbl);
      }
      var sel = fs.querySelector("input:checked");
      if (sel) { zetFilter(sel.getAttribute("data-variant-id")); zetRef(sel.getAttribute("data-variant-id")); }
    });
  }

  // REF-regel (custom-liquid blok "Veem REF"): Horizon's her-render houdt het
  // SKU van de eerste variant vast (Sam 01-10: prijs wisselt, REF niet).
  // Het blok geeft data-skus="variantId:sku,..." mee; hier wisselen we mee.
  function zetRef(vid) {
    var el = document.querySelector(".veem-ref[data-skus]");
    if (!el || !vid) return;
    var sku = "";
    el.getAttribute("data-skus").split(",").forEach(function (paar) {
      var i = paar.indexOf(":");
      if (i > 0 && paar.slice(0, i) === String(vid)) sku = paar.slice(i + 1);
    });
    if (!sku) return;
    var doel = el.querySelector(".veem-ref-sku");
    if (doel && doel.textContent !== sku) doel.textContent = sku;
  }

  /* ---- Sklum-koopkolom: leverlijn, prijs in de knop, Klarna-regel ---- */

  var NL = (document.documentElement.lang || "").indexOf("nl") === 0;

  function prijsTekst() {
    // het prijsblok in de koopkolom; de sticky bar heeft ook een
    // priceContainer, dus altijd via product-price scopen
    var el = document.querySelector(".product-information product-price .price:not(.compare-at-price)") ||
             document.querySelector(".product-information product-price .price");
    return el ? el.textContent.trim() : "";
  }
  function prijsGetal() {
    var t = prijsTekst().replace(/[^0-9,\.]/g, "").replace(/\.(?=\d{3})/g, "").replace(",", ".");
    return parseFloat(t);
  }

  function plusWerkdagen(vanaf, n) {
    var d = new Date(vanaf);
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) n--;
    }
    return d;
  }
  function ddmm(d) {
    return ("0" + d.getDate()).slice(-2) + "/" + ("0" + (d.getMonth() + 1)).slice(-2);
  }

  var TRUCK = '<svg width="18" height="14" viewBox="0 0 18 14" fill="none" aria-hidden="true">' +
    '<path d="M1 1h10v9H1zM11 4h3.2L17 7v3h-6z" stroke="currentColor" stroke-width="1.2" fill="none" stroke-linejoin="round"/>' +
    '<circle cx="4.5" cy="11.5" r="1.6" stroke="currentColor" stroke-width="1.2" fill="none"/>' +
    '<circle cx="13.5" cy="11.5" r="1.6" stroke="currentColor" stroke-width="1.2" fill="none"/></svg>';

  function leverLijn() {
    // De verzendregel met datums staat er ALTIJD (verzoek Ben 02-09):
    // op voorraad -> groene Sklum-regel vervangt de voorraadtekst;
    // uitverkocht -> rode melding blijft, verzendregel eronder.
    var inv = document.querySelector(".product-information product-inventory");
    if (!inv || inv.querySelector(".veem-lever")) return;
    var t = (inv.textContent || "").trim().toLowerCase();
    if (!t) return;
    var FT = window.VEEM_FEITEN || {};  // bron: data/winkelfeiten.json -> settings.veem_*
    var LMIN = FT.levertijdMin || 3, LMAX = FT.levertijdMax || 5;
    var van = plusWerkdagen(new Date(), LMIN);
    var tot = plusWerkdagen(new Date(), LMAX);
    var bereik = ddmm(van) + (NL ? " en " : " and ") + ddmm(tot);
    if (/niet|uitverkocht|out of stock|sold out/.test(t)) {
      var info = NL
        ? "Verzending binnen " + LMIN + "-" + LMAX + " werkdagen na bestelling"
        : "Ships within " + LMIN + "-" + LMAX + " working days of ordering";
      inv.insertAdjacentHTML("beforeend",
        '<span class="veem-lever veem-lever--info">' + TRUCK + "<span>" + info + "</span></span>");
      return;
    }
    var zin = (NL ? "Op voorraad, verwachte levering tussen " : "In stock, estimated delivery between ") + bereik;
    inv.innerHTML = '<span class="veem-lever">' + TRUCK + "<span>" + zin + "</span></span>";
  }

  function knopPrijs() {
    // via data-attribuut + CSS ::after: Horizon stapelt twee tekstlagen in de
    // knop (hover-animatie), een span erin zou dubbel/overlappend renderen
    var btn = document.querySelector(".product-information .buy-buttons-block .add-to-cart-button");
    if (!btn) return;
    if (btn.disabled || btn.hasAttribute("disabled")) {
      btn.removeAttribute("data-veem-prijs");
      return;
    }
    var p = prijsTekst();
    if (!p) return;
    var tekst = "( " + p + " )";
    if (btn.getAttribute("data-veem-prijs") !== tekst) btn.setAttribute("data-veem-prijs", tekst);
  }

  function klarnaRegel() {
    var vorm = document.querySelector(".product-information .buy-buttons-block .product-form-buttons");
    if (!vorm) return;
    var p = prijsGetal();
    if (!(p > 0)) return;
    var termijn = (p / 3).toFixed(2).replace(".", ",");
    var zin = NL
      ? "3 betalingen van €" + termijn + " tegen 0% rente met"
      : "3 payments of €" + termijn + " at 0% interest with";
    var meer = NL ? "Meer informatie" : "More information";
    var bestaand = vorm.parentNode.querySelector(".veem-klarna");
    var logo = "";
    var svgs = document.querySelectorAll(".veem-betaal svg");
    for (var i = 0; i < svgs.length; i++) {
      var kenmerk = (svgs[i].getAttribute("aria-labelledby") || "") + " " + svgs[i].innerHTML.slice(0, 200);
      if (/klarna/i.test(kenmerk)) { logo = svgs[i].outerHTML; break; }
    }
    var html = "<span>" + zin + "</span>" + logo +
      '<a href="https://www.klarna.com/nl/" target="_blank" rel="noopener">' + meer + "</a>";
    if (bestaand) {
      if (bestaand.getAttribute("data-p") !== String(p)) {
        bestaand.setAttribute("data-p", String(p));
        bestaand.innerHTML = html;
      }
      return;
    }
    var el = document.createElement("div");
    el.className = "veem-klarna";
    el.setAttribute("data-p", String(p));
    el.innerHTML = html;
    vorm.after(el);
  }

  function koopkolom() { leverLijn(); knopPrijs(); klarnaRegel(); }

  // tabs Beschrijving | Afmetingen | Details (delegatie: overleeft re-renders)
  document.addEventListener("click", function (e) {
    var b = e.target && e.target.closest && e.target.closest(".veem-tab");
    if (!b) return;
    var wrap = b.closest(".veem-tabs");
    wrap.querySelectorAll(".veem-tab").forEach(function (t) {
      t.classList.toggle("is-actief", t === b);
    });
    wrap.querySelectorAll(".veem-tab-paneel").forEach(function (pn) {
      pn.hidden = pn.getAttribute("data-veempaneel") !== b.getAttribute("data-veemtab");
    });
  });

  document.addEventListener("change", function (e) {
    var t = e.target;
    if (t && t.matches && t.matches("fieldset.veem-swatches input[type=radio]")) {
      // direct filteren op klikmoment; de CSS-regel vangt de her-render op
      zetFilter(t.getAttribute("data-variant-id"));
      requestAnimationFrame(syncDots);
    }
  }, true);

  var bezig = false;
  new MutationObserver(function () {
    if (bezig) return;
    bezig = true;
    requestAnimationFrame(function () { bouw(); discountChip(); koopkolom(); syncDots(); bezig = false; });
  }).observe(document.body, { childList: true, subtree: true });

  function start() { bouw(); discountChip(); koopkolom(); syncDots(); }
  if (document.readyState !== "loading") start();
  else document.addEventListener("DOMContentLoaded", start);
})();
